import React, { useState } from 'react'
import {
  Card,
  Grid,
  Typography,
  Button,
  useMediaQuery,
  Box,
  useTheme,
} from '@mui/material'
import NoticeCarosel from '../../Component/Carosel/Notice_Carosel'

const Study_with_us = () => {
  const [showFullDescription, setShowFullDescription] = useState(false)
  const Theme = useTheme()

  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down('sm'))

  const Study_with = {
    SU: {
      title: 'Study With Us',
      description:
        "College is an exciting and transformative experience! It's a place where you can pursue your passions, gain knowledge, and prepare for your future career. In our college you will have the opportunity to explore different subjects, meet new people, and engage in various extracurricular activities. It's a time of growth, learning, and self-discovery. Our college is a higher education institution where students pursue undergraduate or postgraduate degrees in various fields of study. It typically offers a wide range of majors and programmes allowing students to specialise in their areas of interest. College campuses often provide a vibrant and diverse community where students can engage in extracurricular activities, join clubs, and participate in events.",
    },
  }

  const toggleDescription = () => {
    setShowFullDescription(!showFullDescription)
  }

  return (
    <Box sx={{ padding: 2 }} className="container">
      <Grid container spacing={4}>
        {/* Left Section */}
        <Grid item xs={12} md={6}>
          <Typography variant="h4" gutterBottom>
            {Study_with.SU.title}
          </Typography>
          <Typography
            variant="body1"
            sx={{
              color: Theme.palette.text.secondary,
              height: showFullDescription || isSmallScreen ? 'auto' : '100px',
              overflow:
                showFullDescription || isSmallScreen ? 'visible' : 'hidden',
            }}
          >
            {showFullDescription
              ? Study_with.SU.description
              : Study_with.SU.description.slice(0, 155) +
                (Study_with.SU.description.length > 300 ? '...' : '')}
          </Typography>
          <Button onClick={toggleDescription}>
            {showFullDescription ? 'Read Less' : 'Read More'}
          </Button>
        </Grid>

        {/* Right Section */}
        <Grid item xs={12} md={6}>
          <Card
            sx={{
              backgroundImage: 'linear-gradient(180deg, #F15215, #2391d0)',
              borderRadius: 2,
              padding: 2,
              height: '100%', // Optional: if you want the card to fill available space
            }}
          >
            <NoticeCarosel />
          </Card>
        </Grid>
      </Grid>
    </Box>
  )
}

export default Study_with_us
